import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase'

import Home from './views/Home.vue'
import Settings from './views/Settings.vue'
import Login from './views/Login.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: {
        showQuests: false,
        showObjectives: false,
        showLogs: true
      },

      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/logs',
      name: 'logs',
      component: Home,
      props: {
        showQuests: false,
        showObjectives: false,
        showLogs: true
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/objectives',
      name: 'objectives',
      component: Home,
      props: {
        showQuests: false,
        showObjectives: true,
        showLogs: false
      },
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/quests',
      name: 'quests',
      component: Home,
      props: {
        showQuests: true,
        showObjectives: false,
        showLogs: false
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (!requiresAuth && currentUser) {
    next('/')
  } else {
    next()
  }
})

export default router
